export default __webpack_public_path__ + "static/media/set_8_Video-7.4e0df089.svg";